/**
 * @author Hiroki Moto
 * @description https://marvelapp.com/1152g05j/screen/67851879
 */

import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import find from 'ramda/src/find';
import propEq from 'ramda/src/propEq';
import isEmpty from 'ramda/src/isEmpty';
import Avatar from '@components/@core/Avatar';
import Button from '@components/@core/AnimatedButton';
import Icon from '@components/@core/Icon';
import Rating from '@components/@core/Rating';
import ProductRating from './ProductRating';
import { convertUrl } from '~/services/util';

const BasicShow = ({ data, categories, title, onDetail }) => {
    const navigate = useNavigate();
    const popularProducts = useSelector((state) => state.vendor.popularProducts);
    const categoryProducts = find(propEq('id', data.category?.id ? data?.category?.id : data?.data?.category), categories);
    const productList = Array.isArray(categoryProducts?.popular) ? categoryProducts?.popular : categoryProducts?.popular?.data;
    const filterCategoryProducts = productList?.filter((category) => category?.data?.sponsored_level !== 'wiki');
    const nonCategoryProducts = popularProducts?.data?.filter((p) => p.data.sponsored_level === 'gold');
    const getMultipleRandomProducts = (arr, num) => {
        const shuffled = [...arr].sort(() => 0.5 - Math.random());
        return shuffled.slice(0, num);
    };
    const topProducts = isEmpty(filterCategoryProducts) ? getMultipleRandomProducts(nonCategoryProducts, 4) : filterCategoryProducts?.concat(getMultipleRandomProducts(nonCategoryProducts, 4));

    return (
        <>
            <div className="d-flex ai-end mb-3">
                <span className="dsl-b24 bold">{title}</span>
            </div>
            <div className="d-flex mt-3 flex-md-row flex-column">
                <div className="d-flex-2">
                    <ProductRating className="pb-4 me-5 border-bottom" data={data} />
                    <p className="dsl-b18 bold mt-4">Contact</p>
                    <div className="contact mt-4">
                        <Icon name="fas fa-phone-alt head" color="dark" size={14} />
                        <span className="dsl-b16">Not provided</span>
                    </div>
                    <div className="contact mt-4">
                        <Icon name="fas fa-window-maximize head" color="dark" size={14} />
                        <span className="dsl-b16">Not provided</span>
                    </div>
                    <div className="contact mt-4">
                        <Icon name="fas fa-envelope head" color="dark" size={14} />
                        <span className="dsl-b16">Not provided</span>
                    </div>
                </div>
                <div className="d-flex-5 mt-4 mt-md-0">
                    <p className="dsl-b18 bold">About</p>
                    <div className="about-section">
                        <p className="dsl-b16">{data.data?.description}</p>
                    </div>

                    <div className="top-rated mt-4">
                        <p className="dsl-b18 bold mt-2 mb-3">Related Products</p>
                        {topProducts?.map((item, index) => {
                            if (index > 2) return;
                            const url = convertUrl(item.logo, '/images/default_company.svg');
                            return (
                                <div className="product ai-center jc-between mb-3" onClick={() => onDetail(item)} key={index}>
                                    <div className="d-flex ai-center p-2">
                                        <Avatar type="logo" url={url} name={item?.parent?.name} size="small" borderColor="#e0e0e0" borderWidth={1} />
                                        <div className="ml-3">
                                            <p className="dsl-b16 text-400 mb-1">{item?.parent?.name}</p>
                                            <Rating score={Math.round(Number(item?.stats?.rating_avg) * 100) / 100} />
                                            <p className="dsl-b16 mb-1">
                                                {(Math.round(item.stats?.rating_recommended_avg * 100) / 100) | 0}% Recommended{', '}
                                                {item.stats?.rating_count} Ratings
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                        <div className="d-flex jc-end mt-3">
                            <Button onClick={() => navigate(`/vendor-ratings/by-category/${data.category.id}`)} type="medium">
                                View Related Products
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

BasicShow.propTypes = {
    data: PropTypes.any,
    title: PropTypes.string,
};

BasicShow.defaultProps = {
    data: {},
    title: 'HCM',
};

export default BasicShow;
